import axios from "axios";
// import qs from 'qs';
import bus from "@utils/bus";

// const serviceAxios = axios.create({
//     // baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'http://69.171.69.13:3001', // api的base_url
//     // baseURL: '',
//     // timeout: 20000 // request timeout
// })

// 请求时拦截器
axios.interceptors.request.use(
    config => {
        // 发送请求之前的处理, (eg: loading)
        // console.log('request:', config.noLoading);
        if (!config.noLoading) {
            bus.dispatch("loadingChange", true);
        }
        return config;
    },
    error => {
        // 请求异常的处理
        return Promise.reject(error);
    }
);

// 请求完成后拦截器
axios.interceptors.response.use(
    res => {
        // 返回时的处理
        if (!res.config.noLoading) {
            // console.log('response:', res.config);
            bus.dispatch("loadingChange", false);
        }
        return res;
    },
    error => {
        // 响应异常的处理
        if (!error.config.noLoading) {
            bus.dispatch("loadingChange", false);
        }
        return Promise.resolve(error.response);
    }
);

function errorState(res) {
    // 隐藏 loading

    // 如果 http 状态码正常, 则直接返回数据
    // if (res && (res.status === 200 || res.status === 304 || res.statuss === 400)) {
    //     return res;
    // } else {
    //     console.log('网络异常');
    // }
    if (res && res.status === 403) {
        bus.dispatch("forbidden");
        return res;
    } else {
        console.log("网络异常");
    }
}

function successState(res) {
    // 隐藏 loding
    if (res && res.status === 403) {
        bus.dispatch("forbidden");
    }
}

const request = (opts, data, headers) => {
    // 公共参数
    let pulicparam = {
        // 'params': ''
    };
    // http 默认设置
    let httpDefaultOpts = {
        method: opts.method,
        url: opts.url,
        timeout: 100000,
        withCredentials: true, // 默认的
        // emulateJSON: false,
        params: Object.assign(pulicparam, data), // get
        data: Object.assign(pulicparam, data), // post
        responseType: opts.responseType || "json",
        noLoading: opts.noLoading || false
        // headers: {
        //     // 'CURRENT_ACCOUNT_ID': '5c04ec651bdc9960b6665df7'
        // }
        // headers: headers
        // headers: { // 请求头信息
        //     // 'X-Requested-With': 'XMLHttpRequest',
        //     // 'Accept': 'application/json',
        //     'Content-Type': 'application/json; charset=UTF-8'
        // }
        // : {
        //     'X-Requested-With': 'XMLHttpRequest',
        //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        // }
    };

    if (opts.method === "get") {
        delete httpDefaultOpts.data;
    } else {
        delete httpDefaultOpts.params;
    }

    const promise = new Promise((resolve, reject) => {
        axios(httpDefaultOpts)
            .then(res => {
                successState(res);
                resolve(res);
            })
            .catch(err => {
                errorState(err);
                reject(err);
            });
    });

    return promise;
};

export default request;
